// extracted by mini-css-extract-plugin
export default {"StoryboardNavButton":"StoryboardNavButton","editable":"editable"};